import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 10% of transactions
  // Session Replay
  replaysSessionSampleRate: 0.0, // Don't record normal sessions
  replaysOnErrorSampleRate: 1.0, // Record 100% of sessions that crash
  
  // PII Scrubbing
  beforeSend(event) {
    // Basic scrubbing of common sensitive keys if they leak into error messages
    if (event.request && event.request.headers) {
      delete event.request.headers['Authorization'];
    }
    return event;
  }
});

// Fallback UI when the app completely crashes
const Fallback = ({ error }) => (
  <div style={{ padding: '2rem', color: '#ff4444', background: '#0a0a0f', height: '100vh', fontFamily: 'monospace' }}>
    <h2>Fatal UI Error</h2>
    <p>Our engineers have been notified automatically via Sentry.</p>
    <p>{error.toString()}</p>
    <pre style={{ whiteSpace: 'pre-wrap', marginTop: '1rem', padding: '1rem', background: '#000' }}>{error.stack}</pre>
  </div>
);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={Fallback}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
